<!--
 * @Author: zhaoyang
 * @Date: 2020-10-23 10:28:03
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-10 14:27:22
 * @Description: 拒绝退款详情展示
-->
<template>
  <div class="detail-container">
    <div class="info-item">
      <span class="info-label">{{$t('components_order_refound_reject_detail_1798')}}</span
      ><span>{{ refoundInfo.rejectReason | tuiRejectReason }}</span>
    </div>
    <div class="info-item">
      <span class="info-label">{{$t('components_order_corder_refound_detail_609')}}</span>
      <span class="desc-con">
        {{
          refoundInfo.rejectDesc
            ? refoundInfo.rejectDesc
            : refoundInfo.rejectDesc
        }}</span
      >
    </div>
    <div class="info-item img-con">
      <span class="info-label">{{$t('components_order_corder_refound_detail_610')}}</span>
      <upload-view
        v-if="refoundInfo.rejectImages && refoundInfo.rejectImages.length"
        :images="refoundInfo.rejectImages"
      ></upload-view>
      <img v-else src="" alt="" />
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import uploadView from '@/components/common/upload/upload-view';
export default {
  created() {},
  props: {
    refoundInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    userType: {
      type: String,
      default: () => {
        return 'master';
      },
    },
  },
  computed: {
    refoundSkillInfo() {
      if (!this.refoundInfo.tradeRefundDetailList) return {};
      return this.refoundInfo.tradeRefundDetailList[0] || {};
    },
    refoundREason() {
      if (!this.refoundInfo.refundReason) return '';
      const map = {
        C_AGREE: i18n.t('components_order_corder_refound_detail_612'),
        UNABLE_MEET_DEMAND: i18n.t('components_order_corder_refound_detail_613'),
        USER_VIOLATIONS: i18n.t('components_order_corder_refound_detail_614'),
        OTHER: i18n.t('filters_index_89'),
      };
      const key = this.refoundInfo.refundReason;
      return map[key];
    },
  },
  components: {
    uploadView,
  },
};
</script>
<style lang="scss" scoped>
.detail-container {
  font-size: 14px;
  line-height: 15px;
  color: #222c43;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f1f4f6;
}
.info-item {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-wrap: wrap;
  min-height: 48px;
  line-height: 48px;

  img {
    width: 56px;
    height: auto;
  }
}
.info-title {
  height: 53px;
  font-size: 16x;
  font-weight: 500;
  border-bottom: 1px solid #f1f4f6;
}
.info-label {
  color: #636d86;
}
.refound-reason {
  width: 100%;
  margin-top: 8px;
  line-height: 24px;
}
.desc-con {
  word-break: break-all;
  max-width: 200px;
  line-height: 18.1px;
}
.img-con {
  line-height: 20px;
  align-items: flex-start;
}
</style>
